<div class="or-input-with-icon-field" [class.or-input-with-icon-focused]="focused()">
  <input
    class="or-input-with-icon-native"
    [type]="type()"
    [placeholder]="placeholder()"
    [value]="value()"
    [disabled]="disabled()"
    [attr.autocomplete]="autocomplete()"
    (input)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()" />
  @if (icon()) {
    <img class="or-input-with-icon-icon" [src]="icon()" (click)="onIconClick()" />
  }
</div>
